<script lang="ts">
  import type { ColumnDef } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
  import type { WorkOrderRow } from "../../_logic/work-order-table-model"
  import ActionRequiredCell from "./_modules/action-required-cell"
  import AppointmentCell from "./_modules/appointment-cell"
  import BilledCreditsCell from "./_modules/billed-credits-cell"
  import OrderSummaryCell from "./_modules/order-summary-cell"
  import PropertyCell from "./_modules/property-cell"
  import RecipientsCell from "./_modules/recipients-cell"

  type Props = {
    row: WorkOrderRow
    column: ColumnDef
  }

  const { row, column }: Props = $props()
  const cellValue = $derived((row as Record<string, unknown>)[column.id] ?? "")
</script>

{#if column.id === "orderSummary"}
  <OrderSummaryCell {row} />
{:else if column.id === "statusLabel"}
  <AppointmentCell {row} />
{:else if column.id === "propertyLabel"}
  <PropertyCell {row} />
{:else if column.id === "recipientLabel"}
  <RecipientsCell {row} />
{:else if column.id === "actionRequiredLabel"}
  <ActionRequiredCell {row} />
{:else if column.id === "billedCreditsLabel"}
  <BilledCreditsCell {row} />
{:else}
  {cellValue}
{/if}
